import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

//Layouts
import { FullLayoutComponent } from './layouts/full-layout.component';
import { SimpleLayoutComponent } from './layouts/simple-layout.component';

//Component
import { LoginComponent, MainComponent} from './components/index';

import { 
  CnsltnListFwdr,
  ConsultdetailComponent,
  MsgMangmtList,
  FareRateDetailContainer,
  MainContainer,
  QuotationMain,
  CfsList,
  FareallComponent,
  ConsultComponent,
  FwdrMngListContainer,
  CorpSettingComponenet,
  PromotionComponent,
  BannerMngListContainer,
  AccountListComponent,
  ContractListComponent,
  VesselList,
  PortList,
  OperatorsList,
  StatisticsListComponent,
  BoardWriteComponent,
  BoardListComponent,
  BoardPreviewComponent,
  AdminImageUploadComponent,
  FwdrOwnerContainer,
  AnnouncedLineContainer,
  AnnouncedPortContainer,
  ScheduleByDate,
  UserList,
  ConsultingMonitoring
} from './containers/index';

import { AuthGuard } from './guard/index';
import { DeactivateGuard } from './guard/deactivate-guard';
import { FareManagement } from './containers/fare/fare-management';
import { FwdrFareManagement } from './containers/fwdr-fare/fwdr-fare-management';
import { FleetManagement } from './containers/tracking/fleet-management';
import { ScheduleEdit } from './containers/schedule/schedule-edit';
import { GeoFence } from './containers/geo-fence/geo-fence';
import { NewUserList } from './containers/user/new-user-list';
import { RegistSitemapComponent } from './containers/blog/regist-sitemap';
import { P2PScheduleUpload } from './containers/p2p-schedule-upload/p2p-schedule-upload';


export const routes: Routes = [
  {
    path: '', redirectTo: '/quotation/main', pathMatch: 'full',
  },
  {
    path: '', component: SimpleLayoutComponent,
    children: [
      { path:'login', component: LoginComponent, data: { title: 'Login Page' } }
    ]
  },
  {
    path: '', component: FullLayoutComponent, canActivate: [AuthGuard],
    children: [
      { path: 'main', component: MainContainer, data: { title: '메인' }}
    ]
  },
  {
    path: 'quotation', component: FullLayoutComponent, canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'main', pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'main', component: QuotationMain, data: { title: '견적관리 > 메인' }, canActivate: [AuthGuard]},
      { path: 'consult-list', component: CnsltnListFwdr, data: { title: '견적관리 > 포워더' }, canActivate: [AuthGuard]},
      { path: 'consult-detail/:id', component: ConsultdetailComponent, data: { title: '견적관리 > 포워더 > 상세 페이지' }, canActivate: [AuthGuard]},
      { path: 'fare-all/:id', component: FareallComponent, data: { title: '견적관리 > 포워더 > 상세 페이지 > 모든견적 비교' }, canActivate: [AuthGuard]},
      { path: 'fare-detail/:id', component: FareRateDetailContainer, data: { title: '견적관리 > 운임 등록' }, canActivate: [AuthGuard], canDeactivate: [DeactivateGuard]},
      { path: 'current/:id/:id2', component: FareRateDetailContainer, data: { title: '운임관리 > 기존운임관리 > 상세 페이지' }, canActivate: [AuthGuard], canDeactivate: [DeactivateGuard]},
      { path: 'consult', component: ConsultComponent, data: { title: '견적관리 > 물류비 견적 작성' }, canActivate: [AuthGuard]},
      { path: 'consult/:reqNo', component: ConsultComponent, data: { title: '견적관리 > 물류비 견적 작성' }, canActivate: [AuthGuard]},
    ]
  },
  {
    path: 'fare', component: FullLayoutComponent, canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'fcl', pathMatch: 'full' , canActivate: [AuthGuard]},
      { path: 'fcl', component: FareManagement, data: { title: '운임관리 > FCL운임관리', transTp: 0, crgoTp: 0 }, canActivate: [AuthGuard]},
      { path: 'lcl', component: FareManagement, data: { title: '운임관리 > LCL운임관리', transTp: 0, crgoTp: 1 }, canActivate: [AuthGuard]},
      { path: 'air', component: FareManagement, data: { title: '운임관리 > AIR운임관리', transTp: 1, crgoTp: 1 }, canActivate: [AuthGuard]},
    ]
  },
  {
    path: 'fwdr-fare', component: FullLayoutComponent, canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'fcl', pathMatch: 'full' , canActivate: [AuthGuard]},
      { path: 'fcl', component: FwdrFareManagement, data: { title: '운임관리 > FCL운임관리', transTp: 0, crgoTp: 0 }, canActivate: [AuthGuard]},
      { path: 'lcl', component: FwdrFareManagement, data: { title: '운임관리 > LCL운임관리', transTp: 0, crgoTp: 1 }, canActivate: [AuthGuard]},
      { path: 'air', component: FwdrFareManagement, data: { title: '운임관리 > AIR운임관리', transTp: 1, crgoTp: 1 }, canActivate: [AuthGuard]},
    ]
  },
  {
    path: 'fwdr', component: FullLayoutComponent, canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'list', pathMatch: 'full'},
      { path: 'list', component: FwdrMngListContainer, data: {title: '포워더 관리 > 요청 목록'}, canActivate: [AuthGuard]},
      { path: 'setting/:corpId', component: CorpSettingComponenet, data: {title: '포워더 관리 > 회사정보'}, canActivate: [AuthGuard]},
      { path: 'promotion/:corpId', component: PromotionComponent, data: {title: '포워더 관리 > 프로모션 관리'}, canActivate: [AuthGuard]},
    ]
  },
  {
    path: 'fwdr-owner', component: FullLayoutComponent, canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'list', pathMatch: 'full'},
      { path: 'list', component: FwdrOwnerContainer, data: {title: '기업오너관리 > 요청 목록'}, canActivate: [AuthGuard]},
    ]
  },
  {
    path: 'announced-fare', component: FullLayoutComponent, canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'line', pathMatch: 'full'},
      { path: 'line', component: AnnouncedLineContainer, data: {title: '운임공표제 매핑 > 선사'}, canActivate: [AuthGuard]},
      { path: 'port', component: AnnouncedPortContainer, data: {title: '운임공표제 매핑 > 포트'}, canActivate: [AuthGuard]},
    ]
  },
  {
    path: 'message', component: FullLayoutComponent, canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'main', pathMatch: 'full' },
      { path: 'management', component: MsgMangmtList, data: { title: '메시지 관리' }, canActivate: [AuthGuard]}
    ]
  },
  {
    path: 'cfs', component: FullLayoutComponent, canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'list', pathMatch: 'full'},
      { path: 'list', component: CfsList, data: {title: 'CFS 관리 > CFS 목록'}, canActivate: [AuthGuard]}
    ]
  },
  {
    path: 'user', component: FullLayoutComponent, canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'list', pathMatch: 'full'},
      { path: 'list', component: UserList, data: {title: '유저 관리 > 유저 목록'}, canActivate: [AuthGuard]},
      { path: 'list2', component: NewUserList, data: {title: '유저 관리 > 유저 목록'}, canActivate: [AuthGuard]}
    ]
  },
  {
    path: 'promotion', component: FullLayoutComponent, canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'account', pathMatch: 'full'},
      { path: 'account', component: AccountListComponent, data: { title: '프로모션 관리 > 국가 관리'}, canActivate: [AuthGuard]},
      { path: 'contract', component: ContractListComponent, data: { title: '프로모션 관리 > 계약 관리'}, canActivate: [AuthGuard]},
      { path: 'banner', component: BannerMngListContainer, data: {title: '프로모션 관리 > 배너 관리'}, canActivate: [AuthGuard]},
      { path: 'statistics', component: StatisticsListComponent, data: {title: '프로모션 관리 > 통계 관리'}, canActivate: [AuthGuard]}
    ]
  },
  {
    path: 'mapping', component: FullLayoutComponent, canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'vessel', pathMatch: 'full'},
      { path: 'vessel', component: VesselList, data: {title: '매핑 관리 > 선박 관리'}, canActivate: [AuthGuard]},
      { path: 'port', component: PortList, data: {title: '매핑 관리 > 항만 관리'}, canActivate: [AuthGuard]},
      { path: 'operators', component: OperatorsList, data: {title: '매핑 관리 > 운영사 관리'}, canActivate: [AuthGuard]},
    ]
  },
  {
    path: 'tracking', component: FullLayoutComponent, canActivate: [AuthGuard],
    children: [
      {path: '', redirectTo: 'fleet', pathMatch: 'full'},
      {path: 'fleet', component: FleetManagement, data: {title: '트래킹 관리 > 선박 관리'}, canActivate: [AuthGuard]}
    ]
  },
  {
    path: 'schedule', component: FullLayoutComponent, canActivate: [AuthGuard],
    children: [
      {path: '', redirectTo: 'date', pathMatch: 'full'},
      {path: 'date', component: ScheduleByDate, data: {title: '선사 해상 스케줄 수집 관리 > 스케줄 수집 날짜 조회'}},
      {path: 'edit', component: ScheduleEdit, data: {title: '선사 해상 스케줄 수집 관리 > 수집 스케줄 정보 관리'}}
    ]
  },
  {
    path: 'board', component: FullLayoutComponent, canActivate: [AuthGuard],
    children: [
      {path: '', redirectTo: 'list', pathMatch: 'full'},
      {path: 'list/:bbsId', component: BoardListComponent, data: {title: '게시글관리 > 리스트'}, canActivate: [AuthGuard]},
      {path: 'write/:bbsId', component: BoardWriteComponent, data: {title: '게시글관리 > 쓰기'}, canActivate: [AuthGuard]},
      {path: 'edit/:bbsId/:cntntId', component: BoardWriteComponent, data: {title: '게시글관리 > 수정'}, canActivate: [AuthGuard]},
      {path: 'preview/:bbsId/:cntntId', component: BoardPreviewComponent, data: {title: '게시글관리 > 미리보기'}, canActivate: [AuthGuard]}
    ]
  },
  {
    path: 'image-uploader', component: FullLayoutComponent, canActivate: [AuthGuard],
    children: [
      {path: '', redirectTo: 'upload', pathMatch: 'full'},
      {path: 'upload', component: AdminImageUploadComponent, data: {title: '이미지 업로더'}, canActivate: [AuthGuard]},
    ]
  },
  {
    path: 'geo-fence', component: FullLayoutComponent, canActivate: [AuthGuard],
    children: [
      { path: '', component: GeoFence, data: {title: 'Geo Fence'}, canActivate: [AuthGuard]}
    ]
  },
  {
    path: 'sales', component: FullLayoutComponent, canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'list', pathMatch: 'full'},
      { path: 'consult', component: ConsultingMonitoring, data: {title: '물류비 견적 현황'}, canActivate: [AuthGuard]}
    ]
  },
  {
    path: 'blog', component: FullLayoutComponent, canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: '/main', pathMatch: 'full'},
      { path: 'regist', component: RegistSitemapComponent, data: {title: '블로그 Sitemap'}, canActivate: [AuthGuard]}
    ]
  },
  {
    path: 'p2p', component: FullLayoutComponent, canActivate: [AuthGuard],
    children: [
      { path: 'schedule-uploader', component: P2PScheduleUpload, data: {title: 'P2P 스케줄 업로드'}, canActivate: [AuthGuard]}
    ]
    
  }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ],
  providers:[ DeactivateGuard ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app.routing.ts